import { InputValueDetails } from './types';

// --- Place input details used in multiple conditions and/or actions below ---
export const skuNameValueInputDetails = {
  type: 'search',
  queryKey: 'skus',
  valueKey: 'name',
  query: ({ productsGateway }, input, options) => productsGateway.getSkus(input, options),
} satisfies InputValueDetails;
